import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateDistrictDataEntity } from '../../domain/entities/CreateUpdateDistrictDataEntity'

export class CreateUpdateDistrictDataModel extends CreateUpdateDistrictDataEntity {
  boundary?: Array<{
    longitude?: number
    latitude?: number
  }>

  constructor(dataDto: CreateUpdateDistrictDataEntity) {
    super()
    mapEntityProperties<CreateUpdateDistrictDataModel>(this, dataDto, {
      exclude: ['boundaryData'],
      map: {
        externalId: dataDto.externalId ?? dataDto.id,
        boundary: dataDto.boundaryData?.map((boundary) => {
          return {
            latitude: boundary.latitude ?? (boundary as unknown as { lat: number }).lat,
            longitude: boundary.longitude ?? (boundary as unknown as { lng: number }).lng
          }
        })
      }
    })
  }
}
